import React from 'react';
import { FiChevronRight } from "react-icons/fi";
import './ActionControllerComponent.scss';

const ActionControllerComponent = ({ title, isExpanded, toggleExpand, children, isVisible }) => {
    return (
        <div className={`action-controller-component ${isVisible ? 'expanded' : ''}`}>
            <div className="action-controller-header">
                <h3>{title}</h3>
                <button
                    type="button"
                    className={`circular-button ${isExpanded ? 'expanded' : ''}`}
                    onClick={toggleExpand}
                >
                    <FiChevronRight />
                </button>
            </div>
            <div className={`action-controller-body ${isExpanded ? 'expanded' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default ActionControllerComponent;
